import script from "./articlePage.vue?vue&type=script&setup=true&lang=js"
export * from "./articlePage.vue?vue&type=script&setup=true&lang=js"

import "./articlePage.vue?vue&type=style&index=0&id=13a4193c&lang=less"

const __exports__ = script;

export default __exports__